/**
 * S3互換の画像URLエンコード
 *
 * S3はURLパス中の `+` をスペースとして解釈するため、
 * `+` を `%2B` にエンコードする必要がある。
 * 既にエンコード済みのURLに対しては二重エンコードを防ぐ。
 */
export function encodeImageUrl(url: string): string {
  const isAlreadyEncoded = /%[0-9A-Fa-f]{2}/.test(url)
  if (isAlreadyEncoded) {
    return url.replace(/\+/g, '%2B')
  }
  return encodeURI(url).replace(/\+/g, '%2B')
}
